import { GoogleMap, Marker } from '@react-google-maps/api'
import { GoogleMapsLoader } from 'components/GoogleMapsLoader'
import mapTheme from 'data/map-theme.json'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 20px 0 120px 0;

  ${up('sm')} {
    padding: 28px 0 120px 0;
  }
`

const Title = styled.h5`
  display: none;
  margin: 0;
  padding: 0 0 32px 16px;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;

  ${up('sm')} {
    display: block;
  }
`

const MapWrapper = styled.div`
  > div {
    border: 1px solid #c5ccd5;
    border-radius: 10px;
    height: 0;
    padding-bottom: 90%;

    ${up('sm')} {
      padding-bottom: 45%;
    }
  }
`

const MapText = styled.p`
  margin: 0;
  padding-top: 16px;
  color: #757d88;
  font-size: 15px;
  line-height: 21px;
  text-align: center;

  ${up('sm')} {
    padding-top: 24px;
    font-size: 16px;
    line-height: 29px;
  }
`

export const Map: ComponentType = () => {
  const latLng = { lng: -89.5955408, lat: 21.0246637 }

  return (
    <Wrapper>
      <Container>
        <Row>
          <Col>
            <Title>Yucatán Premier en Mérida</Title>
          </Col>
        </Row>
        <Row>
          <Col>
            <GoogleMapsLoader>
              <MapWrapper>
                <GoogleMap
                  zoom={17}
                  center={latLng}
                  options={{
                    mapTypeControl: false,
                    streetViewControl: false,
                    styles: mapTheme as any,
                  }}
                >
                  <Marker position={latLng} icon="/images/pin.svg" />
                </GoogleMap>
              </MapWrapper>
            </GoogleMapsLoader>
            <MapText>Nuestra oficina se encuentra en contraesquina del Colegio Renacimiento.</MapText>
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}
